import { gql } from 'apollo-angular';

export const GET_PAYMENT_METHODS = gql`
  query {
    paymentMethods {
      key
      name
    }
  }
`;

export const GET_PAYMENT_GATEWAY_TYPES = gql`
  query ($tenantId: ID!) {
    paymentGatewayTypes(tenantId: $tenantId) {
      key
      name
    }
  }
`;
